import React from 'react';

export function TriangleExclamationIcon({ className }: { className?: string }) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clip-path="url(#clip0_216_85)">
        <path
          d="M13.9999 26.58C20.9477 26.58 26.5799 20.9477 26.5799 14C26.5799 7.05226 20.9477 1.42 13.9999 1.42C7.05218 1.42 1.41992 7.05226 1.41992 14C1.41992 20.9477 7.05218 26.58 13.9999 26.58Z"
          stroke="#00C6B3"
          stroke-width="2.83"
          stroke-miterlimit="10"
        />
        <path
          d="M23.07 15.44L16.6 5.06999C15.34 3.04999 12.65 3.04999 11.4 5.06999L4.93002 15.44C3.48002 17.77 4.98002 20.95 7.53002 20.95H20.47C23.02 20.95 24.52 17.77 23.07 15.44Z"
          fill="#10406A"
        />
        <path
          d="M15.1202 17.86C15.1202 18.53 14.5902 19.06 13.9202 19.06C13.2502 19.06 12.7002 18.53 12.7002 17.86C12.7002 17.19 13.2502 16.66 13.9202 16.66C14.5902 16.66 15.1202 17.19 15.1202 17.86ZM13.1102 15.84L12.7202 6.82001H15.1002L14.7102 15.84H13.1102Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_216_85">
          <rect width="27.99" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
